/*
*	Skip to navbar navigation
*/
jQuery(document).ready(function($) {
    var skipLinkNavbarMain = $("#skip-link-navbar-top");
	skipLinkNavbarMain.bind('keydown',function(e) {
		if (e.which == 13) {
			var navbarMain = $("#navbar-top");
			if (navbarMain.length > 0) {
				var firstNavMainItem = navbarMain.find('ul > li').first().find('a').first();
				if (firstNavMainItem.length > 0) {
					firstNavMainItem.focus();
				}
			}
		}
	});
});